import { render, staticRenderFns } from "./CamtImportComponent.vue?vue&type=template&id=67c9927a&scoped=true&"
import script from "./CamtImportComponent.vue?vue&type=script&lang=js&"
export * from "./CamtImportComponent.vue?vue&type=script&lang=js&"
import style0 from "./CamtImportComponent.vue?vue&type=style&index=0&id=67c9927a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c9927a",
  null
  
)

export default component.exports